import React from "react";

function QuoteText({ text }: { text: string }) {
  return (
    <p className="text-sm leading-[1.45] text-white italic">
      {text}
    </p>
  );
}

function TestimonialCard({
  name,
  title,
  quote,
  avatarSrc,
}: {
  name: string;
  title: string;
  quote: string;
  avatarSrc: string;
}) {
  return (
    <div className="rounded-[20px] bg-white/12 border border-white/10 p-5 flex flex-col">
      <div>
        <QuoteText text={quote} />
      </div>

      <div className="mt-8 flex items-center gap-3">
        <div className="h-[46px] w-[46px] rounded-[8px] bg-white/5 border border-white/10 overflow-hidden">
          <img
            src={avatarSrc}
            alt={name}
            className="w-full h-full object-cover"
          />
        </div>
        <div className="min-w-0">
          <div className="text-sm font-semibold text-white/90 truncate">
            {name}
          </div>
          <div className="text-[10px] text-white truncate">{title}</div>
        </div>
      </div>
    </div>
  );
}

const stats = [
  { value: "1300+", label: "Active Users" },
  { value: "1000%", label: "More ROI" },
  { value: "267K+", label: "People Connected" },
  { value: "$29M+", label: "Value Generated" },
];

export default function AuthHeroPanel() {
  return (
    <div className="hidden lg:flex w-[62%] h-screen items-center bg-dark-blue relative overflow-hidden">
      {/* Subtle overlay */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,_rgba(255,255,255,0.08),_transparent_60%)]" />

      <div className="relative w-full px-8 xl:px-12">
        <div className="w-full">
          <h1 className="text-h2 font-semibold tracking-[-0.02em] text-white">
            Launch Your Next Campaign &
            <br />
            <span className="text-bright-green">Start Conversations Today.</span>
          </h1>

          <div className="mt-8 rounded-full bg-white/10 border border-white/10 px-6 py-4 flex items-center justify-between">
            {stats.map((s, idx) => (
              <React.Fragment key={s.label}>
                <div className="text-center">
                  <div className="text-white font-semibold text-[20px]">
                    {s.value}
                  </div>
                  <div className="text-white/70 text-xs mt-1">
                    {s.label}
                  </div>
                </div>
                {idx !== stats.length - 1 ? (
                  <div className="w-px h-[36px] bg-white/10" />
                ) : null}
              </React.Fragment>
            ))}
          </div>

          <div className="mt-6 grid grid-cols-2 gap-5">
            <TestimonialCard
              name="Eve Chan"
              title="Founder, Growth Machine"
              quote="Love the software! Very easy to use and helps my lead gen for my marketing agency a ton. Their customer support team did a great job in helping me navigate the product and helping me with my many questions."
              avatarSrc="/auth/eve.svg"
            />
            <TestimonialCard
              name="Al Mehdi"
              title="Agency Owner DigiVibes"
              quote="Innlead has truly transformed the way I generate leads and build my network on LinkedIn. I've been using it for six months, and it has significantly improved my outreach and expanded my..."
              avatarSrc="/auth/mehdi.svg"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

